import React, { useEffect, useState } from 'react'
import './HomeSliderPrincipal.scss'
import axios from 'axios'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { connect } from 'react-redux'
import { CategoryFilter } from '../filters/CategoryFilter';
import { API, PreChangeBrandChosen } from '../hooks/config';
import { setAllProducts, setProductsTable, resetFilters, pushFilters, setSelectedCategory, setPaginationState, showSpinner } from '../actions'
import { selectCategoryExpositor, selectCategoryImplantations, selectCategoryOutlet, selectCategoryPromoA, selectCategoryPromoB, selectCategoryPromoC } from '../hooks/selectCategory';
import { useNavigate } from 'react-router-dom';
import { getProducts } from '../hooks/gets';
import { PopupOneButton } from './PopupOneButton';
import _ from 'lodash';

const HomeSliderPrincipal = (props) => {
    const navigate = useNavigate();
    const [banners, setBanners] = useState([])
    const [showPopupPresupuestosPendientes, setShowPopupPresupuestosPendientes] = useState(false)

    useEffect(() => {
        axios.get(`${API}/banners-home`).then(res => {
            setBanners(res.data)
        }).catch(err => {
            console.log(err);
        })
    }, [])

    const changeBrandGlobal = (marca = 'fansa') => {
      return new Promise(async (resolve)=>{
        let marcaCambiada = await PreChangeBrandChosen(marca, props.budget)
        if(!marcaCambiada){
          setShowPopupPresupuestosPendientes(true)
          resolve(false)
        }else{
          resolve(true)
        }
      })
    }

    const handleClick = async (value) => {
        const statePromoA = _.filter(props.otherCategoriesAll, ['Name', 'Promoción A'])[0]
        const statePromoB = _.filter(props.otherCategoriesAll, ['Name', 'Promoción B'])[0]
        const statePromoC = _.filter(props.otherCategoriesAll, ['Name', 'Promoción C'])[0]
        if (value.indexOf('categoria') > -1) {
            const valueSplit = value.split('/')
            const categorieId = valueSplit[valueSplit.length - 1]
            for (let i = 0; i < props.categoriesAll.length; i++) {
                const categorie = props.categoriesAll[i];
                if (parseInt(categorieId) === categorie.ID) {
                    getProducts().then(async res => {
                        props.setAllProducts(res)
                        const categoryFilter = new CategoryFilter(categorie.Name)
                        props.setProductsTable('allProducts')
                        props.setSelectedCategory({
                            categoryId: categorie.ID,
                            subtitle: categorie.Name,
                            img: categorie.ImgBanner,
                            selectedCollection: ''
                        })
                        props.resetFilters()
                        await props.pushFilters(categoryFilter)
                        navigate(`/categoria/${categorieId}`)
                    }).catch(err => {
                        props.showSpinner(false)
                    })
                }
            }
        } else if (value.indexOf('outlet') > -1) {
          changeBrandGlobal().then((res)=>{
            if(res == true) {
              selectCategoryOutlet(props).then(res => {
                  navigate('/outlet')
              }).catch(err => {
                  console.log('err', err)
              })
            }
          })
        } else if (value.indexOf('expositores') > -1) {
            changeBrandGlobal().then((res)=>{
              if(res == true) {
                selectCategoryExpositor(props).then(res => {
                    navigate('/expositores')
                }).catch(err => {
                    console.log('err', err)
                })
              }
            })
        } else if (value.indexOf('mplantaciones') > -1) {
            changeBrandGlobal('scheurich').then((res)=>{
              if(res == true) {
                selectCategoryImplantations(props).then(res => {
                    navigate('/implantaciones')
                }).catch(err => {
                    console.log('err', err)
                })
              }
            })
        } else if (value.indexOf('promo-a') > -1 && statePromoA.Active === true) {
            await selectCategoryPromoA(props)
            navigate('/promo-a')
        } else if (value.indexOf('promo-b') > -1 && statePromoB.Active === true) {
            await selectCategoryPromoB(props)
            navigate('/promo-b')
        } else if (value.indexOf('promo-c') > -1 && statePromoC.Active === true) {
            await selectCategoryPromoC(props)
            navigate('/promo-c')
        } else if (value.indexOf('/producto') > -1) {
            const valueSplit = value.split('/')
            const productId = valueSplit[valueSplit.length - 1]
            navigate(`/producto/${productId}`)
        }
    }

    return (
        <div className={banners.length > 0 ? "home-slider-principal" : "home-slider-principal vacio"}>
            {showPopupPresupuestosPendientes &&
                <PopupOneButton title="¡Presupuestos pendientes!" text="Tienes presupuestos pendientes, para cambiar de marca debes guardar o eliminar los presupuestos." textButton="Aceptar" onClick={() => setShowPopupPresupuestosPendientes(false)} />
            }
            {banners.length > 0 &&

                <Carousel
                    className="carousel-style pointer"
                    interval="7000"
                    showThumbs={false}
                    infiniteLoop={true}
                    autoPlay={true}>
                    {
                        banners.map(banner => {
                            return (
                                <div className="image" key={banner.id} onClick={() => { handleClick(banner.href) }}>
                                    <img src={banner.img} alt={banner.id} />
                                </div>
                            )
                        })
                    }
                </Carousel>
            }
        </div>
    )
}

const mapDispatchToProps = {
    setAllProducts,
    setProductsTable,
    resetFilters,
    pushFilters,
    setPaginationState,
    setSelectedCategory,
    showSpinner
}

const mapStateToProps = state => state

export default connect(mapStateToProps, mapDispatchToProps)(HomeSliderPrincipal);